import { useContainerBlockContext } from '@lighthouse/block'
import { getWithScopeId, useAtomAction } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

import { kanbanColumnsSortCacheAtomFamily } from '@/atoms/storage/state'

interface useKanbanColumnsSortPayload {
    appId: string
    envId: string
    blockId: string
}

export const useKanbanColumnsSort = (payload: useKanbanColumnsSortPayload) => {
    const { appId, envId, blockId } = payload
    const { scope } = useContainerBlockContext()
    const withScopeId = getWithScopeId(blockId, scope)
    const { run: setKanbanColumnsSortCache } = useAtomAction(kanbanColumnsSortCacheAtomFamily({ appId, envId, id: withScopeId }))
    const kanbanColumnsSortCache = useAtomValue(kanbanColumnsSortCacheAtomFamily({ appId, envId, id: withScopeId }))

    return useMemo(() => ({ kanbanColumnsSortCache, setKanbanColumnsSortCache }), [kanbanColumnsSortCache, setKanbanColumnsSortCache])
}
